import { ModulesManagerService } from "../Module/modules-manager.service";

export class UserContact {
    private id: number = 0;
    private firstName: string = "";
    private lastName: string = "";
    private society: string = "";
    private phoneNumber: string = "";
    private email: string = "";
    private isDefault: boolean = false

    constructor(private manager: ModulesManagerService, Data: any = null) {
        if (Data != null) {
            this.Hydrate(Data)
        }
    }

    async Hydrate(Data, UpdateAnnex = false) {
        // hydrate les setter 
        for (const [propertie, values] of Object.entries(Data))
            this[this.manager.Tool.minimilizeFirstChar(propertie)] = values

    }

    get Id() {
        return this.id
    }

    get FirstName() {
        return this.firstName || ""
    }

    set FirstName(value: string) {
        this.firstName = value
    }

    get LastName() {
        return this.lastName || ""
    }

    set LastName(value: string) {
        this.lastName = value
    }

    get Society() {
        return this.society || ""
    }

    set Society(value: string) {
        this.society = value
    }

    get PhoneNumber() {
        return this.phoneNumber || ""
    }

    set PhoneNumber(value: string) {
        this.phoneNumber = value
    }

    get Email() {
        return this.email || ""
    }

    get DisplayName() {
        return (this.FirstName != "" ? this.manager.Tool.capitalizeFirstChar(this.FirstName) + " " : "") + this.manager.Tool.capitalizeFirstChar(this.LastName)
    }

    get IsDefault() {
        return this.isDefault
    }

    // set IsDefault(value: boolean) {
    //     if (this.isDefault == value) return
    //     this.isDefault = value
    // }

    async setDefault(forced = null) {
        this.isDefault = forced == null ? !this.isDefault : forced

        await this.manager.Ws.Send("UsersContacts", "update", { Email: this.email, IsDefault: this.isDefault }, true)
    }

    inFilter(text: string) {
        text = text.toLocaleLowerCase()
        return this.DisplayName.toLocaleLowerCase().includes(text) ||
            this.Email.toLocaleLowerCase().includes(text) ||
            this.PhoneNumber.toLocaleLowerCase().includes(text) ||
            this.Society.toLocaleLowerCase().includes(text)
    }

    navigateTo() {
        this.manager.Navi.navigateTo("contacts", { email: this.Email })
    }
}
